<template>
    <div>
        <div class="content-header row">
            <div class="content-header-left col-md-6 col-12 mb-2">
                <h3 class="content-header-title mb-0">{{ pageName }}</h3>
                <div class="row breadcrumbs-top">
                    <div class="breadcrumb-wrapper col-12">
                        <ol class="breadcrumb">
                            <li class="breadcrumb-item"><a href="/">Home</a></li>
                            <li class="breadcrumb-item">Settings</li>
                            <li class="breadcrumb-item active">{{ pageName }}</li>
                        </ol>
                    </div>
                </div>
            </div>
        </div>

        <div class="content-body">
            <section class="card">
                <div class="card-header">
                    <h4>{{ pageName }}</h4>
                </div>
                <div class="card-body">
                    <div class="row">
                        <div class="col-12 col-sm-6">
                            <div class="form-group">
                                <label>Referrer Amount (₦)</label>
                                <input v-model="form.referrer_amount" type="number" min="0" class="form-control">
                            </div>
                            <div class="form-group">
                                <label>Message</label>
                                <textarea v-model="form.message" class="form-control" rows="4"></textarea>
                            </div>
                        </div>
                        <div class="col-12 col-sm-6">
                            <div class="form-group">
                                <label>Receiver Amount (₦)</label>
                                <input v-model="form.user_amount" type="number" min="0" class="form-control">
                            </div>
                            <div class="form-group">
                                <label>Status</label>
                                <select v-model="form.status" class="form-control">
                                    <option :value="1">Active</option>
                                    <option :value="0">Inactive</option>
                                </select>
                            </div>
                        </div>
                    </div>
                    <div class="col-12 d-flex justify-content-end mt-1">
                        <button class="btn btn-primary" :disabled="saving" @click="updateReferralReward">
                            Update
                            <i v-if="saving" class="fa fa-spinner fa-spin"></i>
                        </button>
                    </div>
                </div>
            </section>
        </div>
    </div>
</template>

<script>
import Layout from '@/Shared/Layout';

export default {
    layout: Layout,
    metaInfo: { title: 'Referral Reward' },
    props: ['referralReward', 'pageName', 'routeName'],
    data() {
        return {
            saving: false,
            form: this.$inertia.form({
                status: 1,
                referrer_amount: 0,
                user_amount: 0,
                message: '',
            }),
        };
    },
    mounted() {
        this.form.status = this.referralReward?.status ? 1 : 0;
        this.form.referrer_amount = this.referralReward?.referrer_amount ?? 0;
        this.form.user_amount = this.referralReward?.user_amount ?? 0;
        this.form.message = this.referralReward?.message ?? '';
    },
    methods: {
        updateReferralReward() {
            this.saving = true;

            this.form.post(route(this.routeName), {
                preserveScroll: true,
                onSuccess: () => {
                    this.saving = false;
                },
                onError: () => {
                    this.saving = false;
                },
                onFinish: () => {
                    this.saving = false;
                },
            });
        },
    },
};
</script>
